import React, {useState} from 'react';
import './TempConversion.css';

export default function TempConversion(props) {
    let [unit, setUnit] = useState("cels")

    function convertToFahrenheit(event) {
        event.preventDefault();
        setUnit("fahr");
    }

    function showCels(event) {
        event.preventDefault();
        setUnit("cels");
    }

    if (unit === "cels") {
        return (
            <div className="TempConversion">
                <h1 className="d-inline">{props.cels}
                    <sup>
                        °C|
                        <button className="unit" onClick={convertToFahrenheit}>°F</button>
                    </sup>
                </h1>
            </div>
        )
    } else {
        let fahr = Math.round(props.cels*9/5)+32
        return (
            <div className="TempConversion">
                <h1 className="d-inline">{fahr}
                    <sup>
                        <button className="unit" onClick={showCels}>°C</button>
                        |°F
                    </sup>
                </h1>
            </div>
        )
    }
    
}